var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 22 22",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-management-v4",
    transform: "translate(-1694.000000, -1560.000000)",
    fill: "#5D87AF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "badge-24px-copy-3",
    transform: "translate(1692.000000, 1558.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,7 L15,7 L15,4 C15,2.9 14.1,2 13,2 L11,2 C9.9,2 9,2.9 9,4 L9,7 L4,7 C2.9,7 2,7.9 2,9 L2,20 C2,21.1 2.9,22 4,22 L20,22 C21.1,22 22,21.1 22,20 L22,9 C22,7.9 21.1,7 20,7 Z M9,12 C9.83,12 10.5,12.67 10.5,13.5 C10.5,14.33 9.83,15 9,15 C8.17,15 7.5,14.33 7.5,13.5 C7.5,12.67 8.17,12 9,12 Z M12,18 L6,18 L6,17.25 C6,16.25 8,15.75 9,15.75 C10,15.75 12,16.25 12,17.25 L12,18 Z M13,9 L11,9 L11,4 L13,4 L13,9 Z M18,16.5 L14,16.5 L14,15 L18,15 L18,16.5 Z M18,13.5 L14,13.5 L14,12 L18,12 L18,13.5 Z",
    id: "Shape",
    vectorEffect: "non-scaling-stroke"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBadge);
export default __webpack_public_path__ + "static/media/blue-badge.3364b69a43b82e9a2ae42efff9aa8e28.svg";
export { ForwardRef as ReactComponent };